<template>
  <div v-if="displayValue" class="explorer-cell">
    <button type="button" class="mono explorer-cell__tap" :title="displayValue" @click="onTap">
      {{ displayValue }}
    </button>
  </div>
  <span v-else class="cell-muted">—</span>
</template>

<script>
import { addressExplorerUrl, txExplorerUrl } from '@/utils/explorers'

export default {
  name: 'ExplorerCell',
  props: {
    value: { type: String, default: '' },
    chain: { type: String, default: '' },
    kind: { type: String, default: 'tx' }
  },
  computed: {
    displayValue() {
      const v = (this.value || '').trim()
      if (!v || v === '—') return ''
      return v
    },
    linkUrl() {
      if (!this.displayValue) return ''
      if (this.kind === 'address') {
        return addressExplorerUrl(this.chain, this.displayValue)
      }
      return txExplorerUrl(this.chain, this.displayValue)
    }
  },
  methods: {
    onTap() {
      const t = this.displayValue
      if (!t) return
      const url = this.linkUrl
      if (url) {
        const w = window.open(url, '_blank', 'noopener,noreferrer')
        if (w) w.opener = null
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(t).then(() => {
          this.$message.success(url ? '已复制，已尝试打开浏览器' : '已复制')
        })
      } else {
        this.$message.warning('当前环境无法复制')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.explorer-cell {
  width: 100%;
  min-width: 0;
  line-height: 1.45;
}
.mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;
  font-size: 12px;
}
.explorer-cell__tap {
  display: block;
  max-width: 100%;
  padding: 0;
  text-align: left;
  background: none;
  border: none;
  color: #2563eb;
  cursor: pointer;
  word-break: break-all;
  &:hover {
    text-decoration: underline;
  }
}
</style>
